import { render, staticRenderFns } from "./chip-display.vue?vue&type=template&id=4275af86"
import script from "./chip-display.vue?vue&type=script&lang=js"
export * from "./chip-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4275af86')) {
      api.createRecord('4275af86', component.options)
    } else {
      api.reload('4275af86', component.options)
    }
    module.hot.accept("./chip-display.vue?vue&type=template&id=4275af86", function () {
      api.rerender('4275af86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/chip/chip-display.vue"
export default component.exports